var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"page","mode":"out-in"}},[(_vm.loading)?_c('div',{staticClass:"cover"},[_c('div',{attrs:{"id":"ballWrapper"}},[_c('div',{attrs:{"id":"ball"}},[_c('img',{attrs:{"src":require("../../../img/identity/logo2.png"),"width":"100%","height":"100%"}})]),_vm._v(" "),_c('div',{attrs:{"id":"ballShadow"}})])]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afc2c3a4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/spinner/Spinner.vue
// module id = qzmM
// module chunks = 54